<template>
  <div>
    <div class="feedback-items">
      <feedback-needs
        v-if="activeTabIndex === 0"
        :chip-data="getNeedsChipData"
        @pref-toggle="needFulfill($event)"
      />
      <feedback-needs
        v-else-if="activeTabIndex === 1"
        :chip-data="getWantsChipData"
        @pref-toggle="wantFulfill($event)"
      />
      <feedback-notes
        v-else-if="activeTabIndex === 2"
        :feedback-notes="notesList"
        @add-feedback-note="uploadNote($event)"
        @update-feedback-note="updateNote($event)"
        @remove-feedback-note="removeNote($event)"
      />
      <feedback-pictures
        v-else-if="activeTabIndex === 3"
        :images="imagesArray"
        @open-upload-modal="showUploadModal = true"
        @remove-image="removeImage($event)"
      />
    </div>
    <default-modal
      :modal-title="'Upload Pics'"
      :show-modal="showUploadModal"
      :width="'450px'"
      @close-modal="showUploadModal = false"
    >
      <upload-image
        :btn-text="'UPLOAD PICS'"
        @upload-new-image="uploadNewImage($event)"
      />
    </default-modal>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import { get } from 'lodash'

import FeedbackNeeds from './FeedbackNeeds'
import FeedbackPictures from './FeedbackPictures'
import FeedbackNotes from './FeedbackNotes'
import DefaultModal from '../../components/modals/DefaultModal'
import UploadImage from '../../views/common/UploadImage'

import { isEmpty } from '../../utils/generalUtils'
import {
  updateWants,
  updateNeeds,
  defaultWantNeed,
  getFeedbackObjectFromProperty
} from '../../services/feedbackCalculationService'

import colors from '../../scss/_colors.scss'

export default {
  components: {
    FeedbackNeeds,
    FeedbackPictures,
    DefaultModal,
    UploadImage,
    FeedbackNotes
  },
  props: {
    feedbackData: {
      type: Object,
      required: true
    },
    activeTabIndex: {
      type: Number,
      default: 0
    }
  },

  data: () => ({
    wantNeedData: defaultWantNeed,
    colors,
    showUploadModal: false,
    newImages: [],
    deletedImages: [],
    notesList: []
  }),

  computed: {
    ...mapState('client', ['clientData']),
    ...mapState('feedback', ['feedbackNote', 'saveNote']),
    ...mapGetters('client', ['clientPreferences']),

    getNeedsChipData() {
      return {
        type: 'Need',
        data: this.wantNeedData.needs,
        class: 'pl-2',
        color: this.colors.hwayzTapestry
      }
    },
    getWantsChipData() {
      return {
        type: 'Want',
        data: this.wantNeedData.wants,
        class: 'pl-2',
        color: this.colors.hwayzDarkenGreen
      }
    },
    imagesArray() {
      const mediaArr = this.feedbackData.feedback.media
        ? [...this.feedbackData.feedback.media, ...this.newImages]
        : this.newImages
      return mediaArr.length
        ? mediaArr.filter(item => !this.deletedImages.includes(item))
        : []
    }
  },

  watch: {
    saveNote(newValue) {
      if (newValue && !isEmpty(this.feedbackNote)) {
        const { index } = this.feedbackNote
        index !== null
          ? this.updateNote(this.feedbackNote)
          : this.uploadNote(this.feedbackNote.note)
        this.setSaveNote(false)
      }
    }
  },

  mounted() {
    this.setFeedbackWantNeed()
    this.setFeedbackNotes()
  },

  created() {
    console.log(this.feedbackData)
  },

  methods: {
    ...mapMutations('feedback', {
      setFeedbackNote: 'SET_FEEDBACK_NOTE',
      setSaveNote: 'SET_SAVE_NOTE'
    }),

    wantFulfill(selectedWant) {
      this.wantNeedData = updateWants(selectedWant, this.wantNeedData)
    },

    needFulfill(selectedNeed) {
      this.wantNeedData = updateNeeds(selectedNeed, this.wantNeedData)
    },
    uploadNewImage(image) {
      this.newImages.push(image)
      this.showUploadModal = false
    },
    removeImage(image) {
      this.deletedImages.push(image)
    },
    removeNote(position) {
      this.notesList.splice(position, 1)
    },
    setFeedbackWantNeed() {
      if (this.clientData && this.clientData.homePrefs) {
        const preferenceObject = this.clientPreferences()

        if (this.feedbackData && this.feedbackData.feedback) {
          this.wantNeedData = getFeedbackObjectFromProperty(
            this.feedbackData,
            preferenceObject
          )
        }
      }
    },
    setFeedbackNotes() {
      this.notesList = [...get(this.feedbackData, 'feedback.notes', [])]
    },
    submit() {
      const data = {
        wants: this.wantNeedData.wants,
        needs: this.wantNeedData.needs,
        removedImagesIndexes: null
      }

      if (this.deletedImages) {
        data.removedImagesIndexes = this.deletedImages
          .map(deletedImage => {
            return this.feedbackData.feedback.media.findIndex(
              item => item === deletedImage
            )
          })
          .sort()
          .reverse()
      }

      if (this.newImages.length) {
        data.newImages = this.newImages
      }

      data.notes = this.notesList

      this.$emit('on-update', data)
    },
    uploadNote(note) {
      this.notesList.push(note)
      this.setFeedbackNote(null)
    },
    updateNote({ note, index }) {
      this.notesList[index] = note
      this.setFeedbackNote(null)
    }
  }
}
</script>

<style lang="sass"></style>
